<template>
<div class="chapter">
<div class="inner_page">
<h1 class="heading">A<span class="smallcaps">LSO BY <br/></span>A<span class="smallcaps">MÉLIE </span>N<span class="smallcaps">OTHOMB</span></h1>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781933372648/tokyo-fiancee" target="_blank">Tokyo Fiancée</a> </em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781933372778/hygiene-and-the-assassin" target="_blank">Hygiene and the Assassin</a> </em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609450885/life-form" target="_blank">Life Form</a></em></p>
<p class="center"><em class="italic"><a href="https://www.europaeditions.com/book/9781609452902/petronille" target="_blank">Pétronille</a></em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// strike-your-heart_00000.vue?a685d43e